import styled, {css} from "styled-components";
import {ISearchClearIconBoxProps} from "./search-clear-icon.box";

export const SearchClearIconDefaultBox = styled.i<ISearchClearIconBoxProps>`
        position: absolute;
        inset-inline-end: 2rem;
        width: 3rem;
        height: 3rem;
        background-image: url("${props => props.theme.assets.images.SpriteSheetPC1920_png.toString()}");
        background-repeat: no-repeat;
        background-position: -857px -643px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        
        ${props => !props.visible && css`
            display: none;
        `}
`;